/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createChatMessagePartDataRoleSchema = z.enum(['user', 'assistant', 'tool'])

export type CreateChatMessagePartDataRoleSchema = z.infer<typeof createChatMessagePartDataRoleSchema>
